"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/*
 * Jira Ticket:
 * Created Date: Mon, 18th Nov 2019, 15:17:53 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2019 The Distance
 */
var validateChangePassword = function validateChangePassword(values, props) {
  var errors = {};
  var translate = props.translate;

  if (values.password) {
    var newPassword = values.password;
    if (!new RegExp(/[^\dA-Z]/i).test(newPassword)) errors.password = 'Password must contain a special character';
    if (!new RegExp(/\d/).test(newPassword)) errors.password = 'Password must contain a number';
    if (!new RegExp(/[a-z]/).test(newPassword)) errors.password = 'Password must contain a lowercase character';
    if (!new RegExp(/[A-Z]/).test(newPassword)) errors.password = 'Password must contain an uppercase character';
    if (newPassword.length < 8) errors.password = 'Password must be at least 8 characters';
  } else {
    errors.password = translate('ra.validation.required');
  }

  return errors;
};

var _default = validateChangePassword;
exports.default = _default;